import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = { class: "text-left p-8 w-full" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-between mb-4"
}
const _hoisted_6 = { class: "w-20" }
const _hoisted_7 = { class: "w-6 h-6" }
const _hoisted_8 = { class: "grid grid-flow-col grid-cols-[auto_1fr_auto]" }
const _hoisted_9 = { class: "w-12 h-12" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "w-6 h-6" }
const _hoisted_12 = {
  key: 1,
  class: "flex mt-8 justify-between"
}
const _hoisted_13 = {
  key: 2,
  class: "flex mt-8 justify-end"
}

import { computed } from 'vue';
import useDialog from '@/composables/useDialog';
import CrossIcon from '@/components/Atoms/Icons/CrossIcon.vue';
import TextModal from '@/components/Atoms/Modals/TextModal.vue';
import SpeakerSolidIcon from '@/components/Atoms/Icons/SpeakerSolidIcon.vue';
import useListenAudio from '@/composables/useListenAudio';
import { useSound } from '@vueuse/sound';
import ButtonRoundedRed from '@/components/Atoms/Buttons/ButtonRoundedRed.vue';
import ButtonRoundedGray from '@/components/Atoms/Buttons/ButtonRoundedGray.vue';
import type { ReturnedValue } from '@vueuse/sound/dist/esm/src/types';

interface Props {
    dialogId: number;
    outSideClosable?: boolean;
    modalClosable?: boolean;
    audio?: string;
    cantBeInterrupt?: boolean;
    icon?: boolean;
    btnLeftText?: string;
    btnLeftFunction?: () => void;
    btnRightText?: string;
    btnRightFunction?: () => void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalContainer',
  props: {
    dialogId: {},
    outSideClosable: { type: Boolean, default: true },
    modalClosable: { type: Boolean, default: true },
    audio: { default: '' },
    cantBeInterrupt: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    btnLeftText: { default: '' },
    btnLeftFunction: { type: Function, default: undefined },
    btnRightText: { default: '' },
    btnRightFunction: { type: Function, default: undefined }
  },
  emits: ['closed'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const { closeAllModals, dialogs } = useDialog();

const handleCloseModal = () => {
    closeAllModals();
    emits('closed');
};

const { listen } = useListenAudio();

const isOpen = computed<boolean>(() => {
    return dialogs[props.dialogId].value;
});

function close() {
    if (props.modalClosable && props.outSideClosable) {
        handleCloseModal();
    }
}
let sound: ReturnedValue | null = null;
if (props.audio !== '') {
    sound = useSound(props.audio, { interrupt: true });
}

function btnLeftWhenClick() {
    if (props.btnLeftFunction === undefined) {
        handleCloseModal();
    } else {
        props.btnLeftFunction();
    }
}

function btnRightWhenClick() {
    if (props.btnRightFunction === undefined) {
        handleCloseModal();
    } else {
        props.btnRightFunction();
    }
}

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "fixed inset-0 z-[1000] bg-gray-500 bg-opacity-75 transition-opacity",
          onClick: close
        }),
        _createElementVNode("div", {
          class: "fixed inset-0 z-[1001] overflow-y-auto",
          onClick: close
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "border-4 border-gray-500 relative transform overflow-hidden rounded-3xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl xl:max-w-2xl xl:w-fit",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (props.icon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _renderSlot(_ctx.$slots, "icon")
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          (props.modalClosable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white",
                                onClick: handleCloseModal
                              }, [
                                _createVNode(CrossIcon),
                                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (props.audio && _unref(sound))
                        ? (_openBlock(), _createBlock(SpeakerSolidIcon, {
                            key: 0,
                            class: "!w-12 !h-12 p-1.5 ml-auto text-gray-600",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(listen)(_unref(sound), props.cantBeInterrupt)))
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(TextModal, { class: "mr-1 text-gray-600 whitespace-pre-line" }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "texte")
                        ]),
                        _: 3
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (props.modalClosable && !props.icon)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white",
                            onClick: handleCloseModal
                          }, [
                            _createVNode(CrossIcon),
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _renderSlot(_ctx.$slots, "specific"),
                  (_ctx.btnLeftText && _ctx.btnRightText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_ctx.btnRightText)
                          ? (_openBlock(), _createBlock(ButtonRoundedRed, {
                              key: 0,
                              class: "w-5/12 flex justify-start",
                              onClick: btnRightWhenClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.btnRightText), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.btnLeftText)
                          ? (_openBlock(), _createBlock(ButtonRoundedGray, {
                              key: 1,
                              class: "w-5/12 flex justify-end",
                              onClick: btnLeftWhenClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.btnLeftText), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.btnLeftText && _ctx.btnRightText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_ctx.btnRightText)
                          ? (_openBlock(), _createBlock(ButtonRoundedRed, {
                              key: 0,
                              class: "flex justify-end",
                              onClick: btnRightWhenClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.btnRightText), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})